import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColaboradoresEncuestadorService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  getinfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    return infoUsu;

  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusColaboradores(anio: number){
    let datos: any = {fechaCertificar: anio,	colaboradores: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusColaboradores(anio: number){
    let datos: any = {fechaCertificar: anio,	colaboradores: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  guardaColaboradores35(anio: number, nombres: any, bd: any){
    let datos: any = {fechaNorma35: anio, columnas: nombres, bdcolaboradores:bd};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GuardarColaboradores35 + this.idEmpresa, datos);
  }

  guardaCentro35(anio: number, nombres: any, bd: any){
    let datos: any = {fechaNorma35: anio, columnas: nombres, bdcentrosTrabajo:bd};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GuardarCentro35 + this.idEmpresa, datos);
  }

  getColaboradoresFast(anio: number, producto: string){ // OBTENER COLACORADORES
    let datos: any = {fechaNorma35: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetColaboradores35 + this.idEmpresa, datos);
  }

  getCentrosFast(anio: number, producto: string){ // OBTENER COLACORADORES
    let datos: any = {fechaNorma35: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetCentro35 + this.idEmpresa, datos);
  }

  getColaboradoresFull(anio: number, producto: string){
    // let datos: any = {fechaCertificar: anio, productoId:producto}; // DESCARGAR COLABORADORES
    let datos: any = {fechaNorma35: anio, productoId:producto, token:'$2y$05$VN3dMRXYzo5UfwAt6MAekO8cuJ3uHcbWqZXyUWIv3g.oTdyaDnGCO'};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getColaboradores + this.idEmpresa, datos);
  }

  getColaboradoresActualizarFull(anio: number, producto: string, empresaId:string){
    let datos: any = {fechaCertificar: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFull + empresaId, datos);
  }

  borrarColaboradores(anio: number, producto: string){
    let datos: any = {fechaNorma35: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.borrarColaboradores35 + this.idEmpresa, datos);
  }

  borrarCentros_trabajo(anio: number, producto: string){
    let datos: any = {fechaNorma35: anio, productoId:producto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.borrarCentros35 + this.idEmpresa, datos);
  }

  // Steps

  getStatu( productoid:any, Idioma: any){
    let datos: any = {productoId: productoid, colaboradores:1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.getStatus + this.idEmpresa, datos);
  }

  saveStatus(idproducto: any){
    let datos: any = {productoId: idproducto,	colaboradores: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);
  }

  desbloquearPasoColabNomr(idproducto: any){
    let datos: any = {productoId: idproducto,	colaboradores: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);
  }

  getColaboradores(fechaNorma35: any, empresaPadre:any,productoId:any){  // Obtener colaboradores cuando un CT es hijo
    let datos: any = {productoId: productoId, fechaNorma35: fechaNorma35};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getColaboradores + empresaPadre, datos);
  }

  getFull_CT(anio: number, producto: string){
    let datos: any = {fechaNorma35: anio, productoId:producto};
    console.log("DAtos");
    this.obtienInfo();
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getCTFull + this.idEmpresa, datos);
  }

  updateStatusModal(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.setBanderaVideo + this.idEmpresa, datos);
  }

  pruebacolaboradores(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.expedientes.getColaboradores + this.idEmpresa, data);
  }

  sendCheck(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendCheck + this.idEmpresa, data);
  }

  getCheck(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getChecked + this.idEmpresa, data);
  }

  getInfoCentros(fecha:number){

    this.obtienInfo();
    let datos = {fechaNorma35:fecha};

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + this.idEmpresa, datos);
  }




}
